import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ResponseRetrieveRecipients } from '../../interfaces/retrieve-recipients';
import {
  DOWNLOAD_EXPORT,
  EDIT_HEADER_STATE,
  RETRIEVE_COMUNICATION_BOARD_LIST,
  RETRIEVE_COMUNICATION_BOARD_LIST_SUCCESS,
  RETRIEVE_DESTINATARI_BACHECA,
  RETRIEVE_DESTINATARI_BACHECA_SUCCESS,
  RETRIEVE_HEADER_DETAIL,
  RETRIEVE_HEADER_DETAIL_SUCCESS,
  RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA,
  RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA_SUCCESS,
  RETRIEVE_MESSAGGI_BACHECA,
  RETRIEVE_MESSAGGI_BACHECA_SUCCESS,
  RETRIEVE_ID_RECIPIENTS,
  RETRIEVE_ID_RECIPIENTS_SUCCESS,
  RETRIEVE_HEADER_LIST,
  RETRIEVE_HEADER_LIST_SUCCESS,
  RETRIEVE_LISTA_RETE_TERZA,
  RETRIEVE_LISTA_RETE_TERZA_SUCCESS,
  RETRIEVE_RECIPIENTS,
  RETRIEVE_RECIPIENTS_SUCCESS,
  RETRIEVE_REPORT_BACHECA,
  RETRIEVE_REPORT_BACHECA_SUCCESS,
  RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA,
  RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA_PUT,
  RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA_SUCCESS,
  RICHIEDI_EXPORT,
  RICHIEDI_EXPORT_SUCCESS,
  SAVE_EDIT_HEADER_DETAIL,
  SAVE_EDIT_HEADER_DETAIL_SUCCESS,
  SAVE_HEADER_DETAIL,
  SAVE_HEADER_DETAIL_SUCCESS,
  SAVE_RECIPIENTS_LIST,
  SAVE_RECIPIENTS_LIST_SUCCESS,
  VERIFY_RECIPIENTS_LIST,
  VERIFY_RECIPIENTS_LIST_SUCCESS,
  EDIT_HEADER_STATE_SUCCESS,
  DOWNLOAD_EXPORT_BACHECA,
  DELETE_EL_BACHECA,
  DELETE_EL_BACHECA_SUCCESS,
  EDIT_RECIPIENTS_LIST,
  EDIT_RECIPIENTS_LIST_SUCCESS,
  RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA_PUT,
} from './communication.actions';
import {
  catchError,
  forkJoin,
  map,
  mergeMap,
  of,
  switchMap,
  throwError,
  withLatestFrom,
} from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiService } from '../../services/api.service';
import { Injectable } from '@angular/core';
import {
  IDeleteElNoticeboard,
  IPayloadBoardList,
  ResponseComunicationBoardList,
} from '../../interfaces/response-comunication-board-list';
import { ResponseReportBoardList } from '../../interfaces/report-comunicazioni-bacheca';
import { IResponseRichiediExport } from '../../interfaces/richiedi-export';
import {
  ADD_TOAST_NOTIFICATION,
  DOWNLOAD_FILE,
} from '../config/config.actions';
import { PayloadHeaderDetail } from '../../interfaces/payload-header-detail';
import {
  ComunicazioniHeader,
  IResponseRetrieveHeaderDetail,
} from '../../interfaces/response-retrieve-header-detail';
import { EsitoEnum } from '../../enum/esito.enum';
import { NotificationTypeEnum } from '@poste-click-connect/shared-ui';
import { ResponseMessageBoardList } from '../../interfaces/messaggi-comunicazioni-bacheca';
import { ResponseRecipientsBoardList } from '../../interfaces/destinatari-comunicazioni-bacheca';
import {
  IPayloadSaveDetailMessageBoardList,
  ResponseSaveDetailComunicationBoardList,
} from '../../interfaces/response-save-detail-comunication-board-list';
import {
  IPayloadInvioDetailMessageBoardList,
  ResponseInvioDetailComunicationBoardList,
} from '../../interfaces/response-invio-detail-comunication-board-list';
import {
  IPayloadSaveDetailMessageBoardListPut,
  ResponseSaveDetailComunicationBoardListPut,
} from '../../interfaces/response-save-detail-comunication-board-list-put';
import { IResponseReteTerzaList } from '../../interfaces/response-reteterza-list';
import {
  IPayloadSaveRecipientsList,
  SaveRecipientsList,
} from '../../interfaces/response-save-recipients-list';
import {
  IPayloadVerifyRecipientsList,
  IResponseVerifyRecipientsList,
} from '../../interfaces/response-verify-recipients-list';
import { ResponseIdRecipients } from '../../interfaces/retrieve-id-recipientslist';
import { PayloadEditStateHeader } from '../../interfaces/payload-edit-state-header';
import dayjs from 'dayjs';
import { FacadeService } from '../../services/facade.service';
import { PersistenceService } from '../../services/persistence.service';

@Injectable()
export class CommunicationEffects {
  constructor(
    private actions$: Actions,
    private api: ApiService,
    private facade: FacadeService,
    private persistence: PersistenceService
  ) {}

  retrieveRecipientsList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_RECIPIENTS),
      switchMap(() => this.api.retrieveRecipients()),
      map((responseRecipients: ResponseRetrieveRecipients) => {
        this.persistence.setDestinatariList({
          result: responseRecipients,
        });
        return RETRIEVE_RECIPIENTS_SUCCESS({
          responseRecipients,
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveBoardList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_COMUNICATION_BOARD_LIST),
      switchMap(({ payload }: { payload: IPayloadBoardList }) => {
        return this.api.ricercaComunicazioneBacheca(payload);
      }),
      map((responseBoardList: ResponseComunicationBoardList) => {
        return RETRIEVE_COMUNICATION_BOARD_LIST_SUCCESS({ responseBoardList });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveReportBacheca$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_REPORT_BACHECA),
      switchMap(({ idBacheca }) => this.api.retrieveReportBacheca(idBacheca)),
      map((responseReportBacheca: ResponseReportBoardList) => {
        return RETRIEVE_REPORT_BACHECA_SUCCESS({
          responseReportBacheca,
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  richiediExport$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RICHIEDI_EXPORT),
      switchMap(({ idDestinatari }) => this.api.requestExport(idDestinatari)),
      map((responseRequestExport: IResponseRichiediExport) => {
        if (responseRequestExport.esito === EsitoEnum.KO) {
          return ADD_TOAST_NOTIFICATION({
            notificationMessage: {
              type: NotificationTypeEnum.ERROR,
              description: responseRequestExport.errorDescr,
            },
          });
        }
        return RICHIEDI_EXPORT_SUCCESS({
          responseRequestExport,
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadExport$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_EXPORT),
      switchMap(
        ({
          idDestinatari,
          typeComunication,
        }: {
          idDestinatari: number;
          typeComunication: string;
        }) => {
          return forkJoin({
            idDestinatari: of(idDestinatari),
            response: this.api.downloadExport(idDestinatari, typeComunication),
          });
          //this.api.downloadExport(idDestinatari, typeComunication);
        }
      ),
      map(
        ({
          idDestinatari,
          response,
        }: {
          idDestinatari: number;
          response: any;
        }) => {
          const todaydate = dayjs().format('YYYYMMDDHHmmss');
          const fileName = `Export_ListaDestinatari_${idDestinatari}_${todaydate}.xlsx`;
          return DOWNLOAD_FILE({
            file: response.body,
            fileName: fileName,
          });
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadExportBacheca$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_EXPORT_BACHECA),
      switchMap(
        ({
          idBacheca,
          typeComunication,
        }: {
          idBacheca: number;
          typeComunication: string;
        }) => {
          return forkJoin({
            idBacheca: of(idBacheca),
            response: this.api.downloadExportBacheca(
              idBacheca,
              typeComunication
            ),
          });
        }
      ),
      map(({ idBacheca, response }: { idBacheca: number; response: any }) => {
        const todaydate = dayjs().format('YYYYMMDDHHmmss');
        const fileName = `Export_DestComunicazione_${idBacheca}_${todaydate}.xlsx`;
        return DOWNLOAD_FILE({
          file: response.body,
          fileName: fileName,
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveHeaderDetail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_HEADER_DETAIL),
      switchMap(({ idHeader }: { idHeader: number }) => {
        return this.api.retrieveHeaderDetail(idHeader);
      }),
      mergeMap(
        (responseRetrieveHeaderDetail: IResponseRetrieveHeaderDetail) => {
          return [
            RETRIEVE_HEADER_DETAIL_SUCCESS({
              responseRetrieveHeaderDetail,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  saveHeaderDetail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SAVE_HEADER_DETAIL),
      switchMap(({ payload }: { payload: PayloadHeaderDetail }) => {
        return this.api.saveHeaderDetail(payload);
      }),
      mergeMap((responseSaveHeaderDetail: IResponseRetrieveHeaderDetail) => {
        return [
          SAVE_HEADER_DETAIL_SUCCESS({
            responseSaveHeaderDetail,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  messageBoardListDetail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_MESSAGGI_BACHECA),
      switchMap(({ idBacheca }: { idBacheca: number }) => {
        return this.api.retrieveMessageBoardList(idBacheca);
      }),
      mergeMap((responseMessaggiBacheca: ResponseMessageBoardList) => {
        return [
          RETRIEVE_MESSAGGI_BACHECA_SUCCESS({
            responseMessaggiBacheca,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  recipientsBoardListDetail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_DESTINATARI_BACHECA),
      switchMap(() => {
        return this.api.retrieveRecipientsBoardList();
      }),
      mergeMap((responseDestinatariBacheca: ResponseRecipientsBoardList) => {
        return [
          RETRIEVE_DESTINATARI_BACHECA_SUCCESS({
            responseDestinatariBacheca,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveReteTerzaList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_LISTA_RETE_TERZA),
      switchMap(() => {
        return this.api.retrieveListaReteTerze();
      }),
      map((responseReteTerzaList: IResponseReteTerzaList) => {
        return RETRIEVE_LISTA_RETE_TERZA_SUCCESS({ responseReteTerzaList });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveHeaderList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_HEADER_LIST),
      switchMap(() => {
        return this.api.retrieveHeaderList();
      }),
      mergeMap((responseRetrieveHeaderList: IResponseRetrieveHeaderDetail) => {
        return [
          RETRIEVE_HEADER_LIST_SUCCESS({
            responseRetrieveHeaderList,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  saveMessageDetailBoardList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA),
      switchMap(
        ({ payload }: { payload: IPayloadSaveDetailMessageBoardList }) => {
          return this.api.retrieveSaveDetailMessageBoardList(payload);
        }
      ),
      mergeMap(
        (
          responseSaveDetailMessageBacheca: ResponseSaveDetailComunicationBoardList
        ) => {
          return [
            RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA_SUCCESS({
              responseSaveDetailMessageBacheca,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  editHeaderState$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EDIT_HEADER_STATE),
      withLatestFrom(this.facade.headerDetail.selectRetrieveHeaderList$),
      switchMap(
        ([{ payload }, headerList]: [
          { payload: PayloadEditStateHeader },
          IResponseRetrieveHeaderDetail | null
        ]) => {
          return forkJoin({
            responseEditHeaderState: this.api.editHeaderState(payload),
            headerList: of(headerList),
          });
        }
      ),
      mergeMap(
        ({
          responseEditHeaderState,
          headerList,
        }: {
          responseEditHeaderState: IResponseRetrieveHeaderDetail;
          headerList: IResponseRetrieveHeaderDetail | null;
        }) => {
          const retActions: any[] = [
            EDIT_HEADER_STATE_SUCCESS({ responseEditHeaderState }),
          ];

          const newHeaderList: IResponseRetrieveHeaderDetail | null =
            headerList?.comunicazioniHeader ? { ...headerList } : null;
          if (
            newHeaderList?.comunicazioniHeader &&
            responseEditHeaderState.comunicazioniHeader?.length &&
            responseEditHeaderState.comunicazioniHeader[0]
          ) {
            newHeaderList.comunicazioniHeader =
              newHeaderList.comunicazioniHeader.map(
                (comHeader: ComunicazioniHeader) => {
                  return comHeader.idHeader ===
                    responseEditHeaderState.comunicazioniHeader![0].idHeader
                    ? responseEditHeaderState.comunicazioniHeader![0]
                    : comHeader;
                }
              );

            retActions.push(
              RETRIEVE_HEADER_LIST_SUCCESS({
                responseRetrieveHeaderList: newHeaderList,
              })
            );
          }

          return retActions;
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  invioMessageDetailBoardList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA),
      switchMap(
        ({ payload }: { payload: IPayloadInvioDetailMessageBoardList }) => {
          return this.api.retrieveInvioDetailMessageBoardList(payload);
        }
      ),
      mergeMap(
        (
          responseInvioDetailMessageBacheca: ResponseInvioDetailComunicationBoardList
        ) => {
          return [
            RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA_SUCCESS({
              responseInvioDetailMessageBacheca,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  invioMessageDetailBoardListPut$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA_PUT),
      switchMap(
        ({ payload }: { payload: IPayloadInvioDetailMessageBoardList }) => {
          return this.api.retrieveInvioDetailMessageBoardListPut(payload);
        }
      ),
      mergeMap(
        (
          responseInvioDetailMessageBacheca: ResponseInvioDetailComunicationBoardList
        ) => {
          return [
            RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA_SUCCESS({
              responseInvioDetailMessageBacheca,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  verifyRecipientsList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(VERIFY_RECIPIENTS_LIST),
      switchMap(({ payload }: { payload: IPayloadVerifyRecipientsList }) => {
        return this.api.verifyListRecipients(payload);
      }),
      mergeMap(
        (responseVerifyRecipientsList: IResponseVerifyRecipientsList) => {
          return [
            VERIFY_RECIPIENTS_LIST_SUCCESS({
              responseVerifyRecipientsList,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  saveMessageDetailBoardListPut$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA_PUT),
      switchMap(
        ({ payload }: { payload: IPayloadSaveDetailMessageBoardListPut }) => {
          return this.api.retrieveSaveDetailMessageBoardListPut(payload);
        }
      ),
      mergeMap(
        (
          responseSaveDetailMessageBachecaPut: ResponseSaveDetailComunicationBoardListPut
        ) => {
          return [
            RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA_SUCCESS({
              responseSaveDetailMessageBacheca:
                responseSaveDetailMessageBachecaPut,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  saveRecipientsList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SAVE_RECIPIENTS_LIST),
      switchMap(({ payload }: { payload: IPayloadSaveRecipientsList }) => {
        return this.api.saveListRecipients(payload);
      }),
      mergeMap((responseSaveRecipientsList: SaveRecipientsList) => {
        return [
          SAVE_RECIPIENTS_LIST_SUCCESS({
            responseSaveRecipientsList,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  editRecipientsList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(EDIT_RECIPIENTS_LIST),
      switchMap(({ payload }: { payload: IPayloadSaveRecipientsList }) => {
        return this.api.editListRecipients(payload);
      }),
      mergeMap((responseEditRecipientsList: SaveRecipientsList) => {
        return [
          EDIT_RECIPIENTS_LIST_SUCCESS({
            responseEditRecipientsList,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveIdRecipients$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_ID_RECIPIENTS),
      switchMap(({ idDestinatari }) =>
        this.api.retrieveIdRecipients(idDestinatari)
      ),
      map((responseRetrieveIdRecipients: ResponseIdRecipients) => {
        return RETRIEVE_ID_RECIPIENTS_SUCCESS({
          responseRetrieveIdRecipients,
        });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  saveEditHeaderDetail$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SAVE_EDIT_HEADER_DETAIL),
      switchMap(({ payload }: { payload: PayloadHeaderDetail }) => {
        return this.api.saveEditHeaderDetail(payload);
      }),
      mergeMap(
        (responseEditSaveHeaderDetail: IResponseRetrieveHeaderDetail) => {
          return [
            SAVE_EDIT_HEADER_DETAIL_SUCCESS({
              responseEditSaveHeaderDetail,
            }),
          ];
        }
      ),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  deleteElBacheca$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DELETE_EL_BACHECA),
      switchMap(({ idBacheca }) => this.api.deleteBachecaEl(idBacheca)),
      map((responseDeleteElBacheca: IDeleteElNoticeboard) => {
        return DELETE_EL_BACHECA_SUCCESS({ responseDeleteElBacheca });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    )
  );
}
